import * as React from "react";

import { cn } from "@corpuscomplete/web-ui/lib/utils";
import { Checkbox } from "@corpuscomplete/web-ui/components/checkbox";
import { RadioGroupItem } from "@corpuscomplete/web-ui/components/radio-group";

interface SelectionCardProps {
  type: "radio" | "checkbox";
  selected: boolean;
  onSelect: () => void;
  title: string;
  description: string;
  value?: string;
  className?: string;
}

function SelectionCard({
  type,
  selected,
  onSelect,
  title,
  description,
  value,
  className,
}: SelectionCardProps) {
  const id = React.useId();

  return (
    <label
      htmlFor={id}
      data-slot="selection-card"
      className={cn(
        "flex cursor-pointer flex-col gap-1 rounded-lg border p-3 transition-colors",
        "border-input hover:bg-muted",
        selected && "border-primary bg-primary/5",
        className,
      )}
    >
      <div className="flex items-center gap-2">
        {type === "radio" ? (
          <RadioGroupItem id={id} value={value ?? ""} />
        ) : (
          <Checkbox id={id} checked={selected} onCheckedChange={() => onSelect()} />
        )}
        <span className="text-sm font-medium">{title}</span>
      </div>
      <p className="text-muted-foreground pl-6 text-xs">{description}</p>
    </label>
  );
}

export { SelectionCard, type SelectionCardProps };
